import { FormControl, InputLabel } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Select, SelectSection, SelectItem, Button } from '@nextui-org/react'
import {
    Dropdown,
    DropdownTrigger,
    DropdownMenu,
    DropdownItem,
} from '@nextui-org/react'
import cn from 'classnames'
import { buttonSearchCommonStyles } from '../../common/styles'

const DropTopFilters = ({ setOrder, orderBy, disabled }) => {
    const { t } = useTranslation('common')
    const dropDownOptions = [
        { value: 'drop_id_desc', label: 'Drop ID (Descending)' },
        { value: 'drop_id_asc', label: 'Drop ID (Ascending)' },
        { value: 'date_desc', label: 'Date (Newest)' },
        { value: 'date_asc', label: 'Date (Oldest)' },
        { value: 'price_asc', label: 'Price (Lowest)' },
        { value: 'price_desc', label: 'Price (Highest)' },
        { value: 'template_id_desc', label: 'Template ID (Descending)' },
        { value: 'template_id_asc', label: 'Template ID (Ascending)' },
        { value: 'author_asc', label: 'Collection (Descending)' },
        { value: 'author_desc', label: 'Collection (Ascending)' },
    ]

    const getOption = (order) => {
        const option = Math.max(
            dropDownOptions.map((item) => item.value).indexOf(order),
            0,
        )

        return dropDownOptions[option]
    }

    return (
        <div>
            <Dropdown
                offset={5}
                placement="bottom-end"
                classNames={{
                    base: 'h-[300px] overflow-y-scroll',
                    trigger: 'p-0 w-[200px]',
                }}
            >
                <DropdownTrigger className="w-[56px]">
                    <Button
                        size="sm"
                        className={cn(
                            '!w-[56px] h-[56px] border-2',
                            buttonSearchCommonStyles,
                        )}
                        variant="bordered"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"
                            />
                        </svg>
                    </Button>
                </DropdownTrigger>
                <DropdownMenu
                    variant="faded"
                    aria-label="Dropdown menu with description"
                    selectionMode="single"
                    selectedKeys={new Set([getOption(orderBy).value])}
                    onSelectionChange={(d) => {
                        setOrder(getOption(Array.from(d)[0]).value)
                    }}
                >
                    {dropDownOptions.map((option) => (
                        <DropdownItem key={option.value} value={option.value}>
                            {option.label}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </div>
    )
}

export default DropTopFilters
